import React, { Component } from 'react'
import './ProflieLoad.scss'
import axios from 'axios'
import Auth from '../../Modules/Auth'

class ProflieLoad extends Component {
    constructor(props) {
        super(props)
        this.state = {
            imagePreviewUrl: '',
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ imagePreviewUrl: nextProps.thumbnailUrl })
    }

    _handleImageChange(e) {
        e.preventDefault()

        const reader = new FileReader()
        const file = e.target.files[0]

        reader.onloadend = () => {
            this.fileUpload()

            this.setState({
                imagePreviewUrl: reader.result,
            })
        }

        reader.readAsDataURL(file)
    }

    fileUpload = () => {
        const thumbnail = document.querySelector('input[type="file"]').files[0]
        const data = new FormData()
        data.append('file', thumbnail)
        axios
            .post(`${BACKEND_HOST}/upload/files/`, data, {
                headers: {
                    Authorization: `bearer ${Auth.getToken()}`,
                },
            })
            .then((res) => {
                this.props.handleProfile(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {
        const { imagePreviewUrl } = this.state
        let $imagePreview = null
        if (imagePreviewUrl) {
            $imagePreview = <img src={imagePreviewUrl} />
        } else {
            $imagePreview = <div className="profile_text">{this.props.label}</div>
        }

        return (
            <div className="proflie_wrap">
                <div>
                    <label htmlFor="fileInput">
                        <div className="profile_img">{$imagePreview}</div>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="28"
                            height="28"
                            viewBox="0 0 28 28">
                            <defs>
                                <path
                                    id="camera1"
                                    d="M15 2C7.85 2 2 7.85 2 15s5.85 13 13 13 13-5.85 13-13S22.15 2 15 2z"
                                />
                                <filter
                                    id="camera2"
                                    width="111.5%"
                                    height="111.5%"
                                    x="-5.8%"
                                    y="-5.8%"
                                    filterUnits="objectBoundingBox">
                                    <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
                                    <feGaussianBlur
                                        in="shadowOffsetOuter1"
                                        result="shadowBlurOuter1"
                                        stdDeviation=".5"
                                    />
                                    <feComposite
                                        in="shadowBlurOuter1"
                                        in2="SourceAlpha"
                                        operator="out"
                                        result="shadowBlurOuter1"
                                    />
                                    <feColorMatrix
                                        in="shadowBlurOuter1"
                                        values="0 0 0 0 0.0156862745 0 0 0 0 0.0941176471 0 0 0 0 0.156862745 0 0 0 0.5 0"
                                    />
                                </filter>
                            </defs>
                            <g fill="none" fillRule="evenodd">
                                <g transform="translate(-1 -1)">
                                    <use fill="#000" filter="url(#camera2)" xlinkHref="#camera1" />
                                    <use fill="#008BFE" xlinkHref="#camera1" />
                                    <path
                                        stroke="#FFF"
                                        strokeWidth="2"
                                        d="M15 3C8.402 3 3 8.402 3 15s5.402 12 12 12 12-5.402 12-12S21.598 3 15 3z"
                                    />
                                </g>
                                <path
                                    fill="#FFF"
                                    d="M20.6 17.38c0 .626-.53 1.134-1.182 1.134H8.782c-.653 0-1.182-.508-1.182-1.135v-6.242c0-.626.53-1.135 1.182-1.135h2.363L12.327 8.3h3.546l1.182 1.702h2.363c.653 0 1.182.509 1.182 1.135v6.242z"
                                />
                                <g transform="translate(10.943 10.993)">
                                    <circle cx="3.232" cy="3.232" r="3.232" fill="#008BFE" />
                                    <circle cx="3.232" cy="3.232" r="1.978" fill="#FFF" />
                                </g>
                            </g>
                        </svg>
                    </label>
                    <input
                        id="fileInput"
                        className="fileInput"
                        type="file"
                        onChange={(e) => this._handleImageChange(e)}
                    />
                </div>
            </div>
        )
    }
}

export default ProflieLoad



// WEBPACK FOOTER //
// ./Src/Components/Commons/ProflieLoad.js